<div class="global-filters" [class.global-filters--mobile]="mobile$ | async">
  <div class="global-filters__select" [class.global-filters__select--mobile]="mobile$ | async">
    <label class="{{ (jobsiteLoader$ | async) ? 'disabled' : '' }}" for="filter-job-sites">{{
      'globalFilters.jobsites.label' | translate
    }}</label>
    <cwc-select
      id="filter-job-sites"
      [label]="'globalFilters.jobsites.label' | translate"
      [filterPlaceholder]="'globalFilters.jobsites.search' | translate"
      [placeholder]="'globalFilters.jobsites.placeholder' | translate"
      (cwcChange)="onJobsiteSelect($event)"
      (cwcFilter)="onJobsiteSearch($event)"
      [filter]="true"
      [filterValue]="jobsiteFilter"
      [filterNoResultsMessage]="'globalFilters.jobsites.noResults' | translate"
      [rtl]="rtl$ | async"
      [disabled]="jobsiteLoader$ | async"
      unwrap
      variant="no-border"
      data-tid="jobsite-filter"
      class="fit-select"
      height="fit-content"
      designVersion="v2"
    >
      <ng-container *ngIf="!jobsiteFilter">
        <ng-container *ngIf="appendJobsite">
          <cwc-select-option [selected]="selectedJobsite.id === preselectedJobsiteId" [value]="selectedJobsite.id" designVersion="v2">
            {{ selectedJobsite | formatJobsite }}
          </cwc-select-option>
        </ng-container>
        <cwc-select-option
          [selected]="preselectedJobsiteId === ALL_JOBSITES"
          *ngIf="calendarViewFilter"
          [value]="ALL_JOBSITES"
          designVersion="v2"
        >
          {{ 'globalFilters.jobsites.all_jobsites' | translate }}
        </cwc-select-option>
        <cwc-select-option
          *ngFor="let jobsite of jobsites"
          [selected]="jobsite.id === preselectedJobsiteId"
          [value]="jobsite.id"
          designVersion="v2"
        >
          {{ jobsite | formatJobsite }}
        </cwc-select-option>
      </ng-container>
      <ng-container *ngIf="jobsiteFilter">
        <cwc-select-option
          *ngFor="let jobsite of allJobsites | filterJobsites: jobsiteFilter"
          [selected]="jobsite.id === preselectedJobsiteId"
          [value]="jobsite.id"
          designVersion="v2"
        >
          {{ jobsite | formatJobsite }}
        </cwc-select-option>
      </ng-container>
    </cwc-select>
  </div>
  <div
    *ngIf="calendarViewFilter"
    class="global-filters__select"
    [class.global-filters__select--mobile]="mobile$ | async"
  >
    <label class="{{ (jobsiteLoader$ | async) ? 'disabled' : '' }}" for="filter-pod">{{
      'global.point_of_delivery' | translate
    }}</label>
    <cwc-select
      id="filter-pod"
      [label]="'global.point_of_delivery' | translate"
      [filterPlaceholder]="'globalFilters.pod.search' | translate"
      [placeholder]="(disablePodFilter ? 'globalFilters.pod.all_pod' : 'views.common.select.pod') | translate"
      (cwcChange)="onPodSelect($event)"
      (cwcFilter)="onPodSearch($event)"
      [filter]="true"
      [filterValue]="podFilter"
      [filterNoResultsMessage]="'globalFilters.pod.no_results' | translate"
      [rtl]="rtl$ | async"
      [disabled]="(jobsiteLoader$ | async) || (podLoader$ | async) || disablePodFilter"
      unwrap
      variant="no-border"
      data-tid="pod-filter"
      designVersion="v2"
    >
      <ng-container *ngIf="!podFilter">
        <cwc-select-option *ngFor="let pod of pods" [value]="pod.id" designVersion="v2">
          {{ pod | formatJobsite }}
        </cwc-select-option>
      </ng-container>
      <ng-container *ngIf="podFilter">
        <cwc-select-option *ngFor="let pod of pods | filterJobsites: podFilter" [value]="pod.id" designVersion="v2">
          {{ pod | formatJobsite }}
        </cwc-select-option>
      </ng-container>
    </cwc-select>
  </div>
  <div
    class="global-filters__select product-line-filter-select"
    [class.global-filters__select--mobile]="mobile$ | async"
  >
    <label class="{{ (jobsiteLoader$ | async) ? 'disabled' : '' }}" for="filter-product-lines">{{
      'globalFilters.productLines.label' | translate
    }}</label>
    <cwc-select
      id="filter-product-lines"
      [label]="'globalFilters.productLines.label' | translate"
      [placeholder]="'globalFilters.productLines.placeholder' | translate"
      [selectAllLabel]="'globalFilters.productLines.all' | translate"
      (cwcChange)="onProducLineSelect($event)"
      [multiple]="true"
      [selectAll]="true"
      [rtl]="rtl$ | async"
      [disabled]="(productLineLoader$ | async) || !(selectedJobsiteId$ | async) || selectingJobsite"
      unwrap
      variant="no-border"
      data-tid="product-line-filter"
      [selectAllMessage]="'globalFilters.productLines.all' | translate"
      designVersion="v2"
    >
      <cwc-select-option
        *ngFor="let productLine of productLines$ | async"
        [selected]="productLine.id | selected: selectedProductLinesIds"
        [value]="productLine.id"
        [disabled]="productLine.disabled"
        designVersion="v2"
      >
        {{ 'globalFilters.productLines.' + productLine.code | translate }}
      </cwc-select-option>
    </cwc-select>
  </div>
  <div
    class="global-filters__select--right"
    [class.global-filters__select--mobile]="mobile$ | async"
    *ngIf="!calendarViewFilter && showCalendarViewAcces && !calendarViewV2"
  >
    <cwc-button variant="link" size="medium" leading-icon="scheduler" (cwcClick)="navigateToCalendarView()" designVersion="v2">
      {{ 'views.calendar_view' | translate }}
    </cwc-button>
  </div>
  <!-- <div
    class="global-filters__select--right"
    [class.global-filters__select--mobile]="mobile$ | async"
    *ngIf="calendarHistoryViewEnable && isOrderHistoryPage"
  >
    <cwc-segmented-controls design-version="v2" (cwcControlActive)="onChangeView($event)">
      <cwc-segmented-controls-item name="calendarHistoryView" leading-icon="calendar" active="true" designVersion="v2">{{ 'views.calendar_view' | translate }}</cwc-segmented-controls-item>
      <cwc-segmented-controls-item name="orderList" leading-icon="list" designVersion="v2">{{ 'views.common.orders_history' | translate }}</cwc-segmented-controls-item>
    </cwc-segmented-controls>
  </div> -->
</div>
